<template>
    <div class="range-slider">
        <input @input="rangeChange"
               @change="rangeChange"
               @mouseup="emitHeightValue"
               @touchend="emitHeightValue"
               type="range"
               name="range1"
               id="height"
               :min="this.$props.minimum"
               :max="this.$props.maximum"
               step="1"
               :data-unit="measurement"
               v-model="value" />
        <span class="range-icon" :style="{left: rangePosition + '%', transform: 'translateX(' + -rangePosition + '%)'}">
            {{ this.rangeText }}
        </span>
    </div>
</template>

<script>
    import Vue from "vue";
    import { mapState, mapGetters } from "vuex";
    import convert from "convert-units";

    export default {
            props: [
            "minimum",
            "maximum",
            "measurement",
            "showMeasurementBeforeNumber",
            "sliderValue"
        ],
        data: function () {
            return {
                value: this.$props.sliderValue,
                rangePosition: 0,
                rangeText: ''
            };
        },
        computed: {
            ...mapState("filters", ["heightMeasureUnitText"]),
            ...mapGetters("filters", ["getMeasurementType"])
        },
        methods: {
            format(n, system, format) {
                if (system == "m") {
                    if (this.showMeasurementBeforeNumber) {
                        return format + n / 100;
                    } else {
                        return n / 100 + format;
                    }
                } else if (system == "c") {
                    if (this.showMeasurementBeforeNumber) {
                        return format + n;
                    } else {
                        return n + format;
                    }
                } else {
                    var realFeet = (n * 0.3937) / 12;
                    var feet = Math.floor(realFeet);
                    var inches = Math.round((realFeet - feet) * 12);
                    return feet + "'" + inches + '"';
                }
            },
            rangeChange(e) {
                this.rangePosition = ((this.value - this.$props.minimum) * 100) / (this.$props.maximum - this.$props.minimum);
                this.rangeText = this.format(this.value, this.getMeasurementType, this.$props.measurement)

                this.$store.commit("filters/filterByHeight", this.value);
            },
            emitHeightValue(e) {
                this.$store.dispatch("filterAttractions");
            }
        },
        mounted() {
            this.rangePosition = ((this.value - this.$props.minimum) * 100) / (this.$props.maximum - this.$props.minimum);
            this.rangeText = this.format(this.value, this.getMeasurementType, this.$props.measurement)
        }
    };
</script>